import React, { useRef, useState, useEffect } from 'react';

export default function Modal({ title, onClose, onSave, children, saveLabel = 'Salvează' }) {
  const [pos, setPos] = useState({ x: 0, y: 0 });
  const [dragging, setDragging] = useState(false);
  const dragStart = useRef(null);
  const modalRef = useRef(null);

  // Center on open
  useEffect(() => {
    if (modalRef.current) {
      const rect = modalRef.current.getBoundingClientRect();
      setPos({ x: 0, y: 0 });
    }
  }, []);

  const onMouseDown = (e) => {
    if (e.target.closest('.modal-close') || e.target.closest('button')) return;
    setDragging(true);
    dragStart.current = {
      mouseX: e.clientX,
      mouseY: e.clientY,
      posX: pos.x,
      posY: pos.y
    };
    e.preventDefault();
  };

  useEffect(() => {
    if (!dragging) return;
    const onMove = (e) => {
      const dx = e.clientX - dragStart.current.mouseX;
      const dy = e.clientY - dragStart.current.mouseY;
      setPos({ x: dragStart.current.posX + dx, y: dragStart.current.posY + dy });
    };
    const onUp = () => setDragging(false);
    window.addEventListener('mousemove', onMove);
    window.addEventListener('mouseup', onUp);
    return () => {
      window.removeEventListener('mousemove', onMove);
      window.removeEventListener('mouseup', onUp);
    };
  }, [dragging]);

  return (
    <div className="modal-overlay">
      <div
        ref={modalRef}
        className="modal"
        onClick={e => e.stopPropagation()}
        style={{
          transform: `translate(${pos.x}px, ${pos.y}px)`,
          transition: dragging ? 'none' : 'transform 0.1s',
          cursor: dragging ? 'grabbing' : 'default'
        }}
      >
        <div
          className="modal-header"
          onMouseDown={onMouseDown}
          style={{ cursor: dragging ? 'grabbing' : 'grab', userSelect: 'none' }}
        >
          <span>✥ {title}</span>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>
        <div className="modal-body">{children}</div>
        {onSave && (
          <div className="modal-footer">
            <button className="btn btn-primary" onClick={onSave}>{saveLabel}</button>
            <button className="btn" style={{ background: '#eee' }} onClick={onClose}>Anulează</button>
          </div>
        )}
      </div>
    </div>
  );
}
